/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_Overview_Popup_DescriptionInputs */

const en_public_docs_overview_popup_description = /** @type {(inputs: Public_Docs_Overview_Popup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Summary, key points, and document details.`)
};

const es_public_docs_overview_popup_description = /** @type {(inputs: Public_Docs_Overview_Popup_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen, puntos clave y detalles del documento.`)
};

/**
* | output |
* | --- |
* | "Summary, key points, and document details." |
*
* @param {Public_Docs_Overview_Popup_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_overview_popup_description = /** @type {((inputs?: Public_Docs_Overview_Popup_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_Overview_Popup_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_overview_popup_description(inputs)
	return en_public_docs_overview_popup_description(inputs)
});